module.exports = __webpack_public_path__ + "media/images/auth-59c80cbc06953b9c2e47c9eaf65f1993.png";